<div>
  <ngx-skeleton-loader [theme]="{height: '56px', width:'100%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
</div>

<div>
  @for (row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track row) {
    <div>
      <ngx-skeleton-loader [theme]="{height: '44px', width:'9%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '44px', width:'9%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '44px', width:'7%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '44px', width:'11%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '44px', width:'10%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '44px', width:'18%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '44px', width:'16%', 'margin-right': '0.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '44px', width:'16.5%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
    </div>
  }
</div>

<div class="paginator">
  <ngx-skeleton-loader [theme]="{ height: '40px', width: '40%', 'margin-bottom': '0.3%' }" appearance="line"></ngx-skeleton-loader>
</div>
